export default __webpack_public_path__ + "static/media/call.4315de8d.svg";